import { Component, OnInit } from '@angular/core';
import { SaveService } from '../shared/services/save.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AuthService } from '../shared/security/auth.service';
import { Router } from '@angular/router';
import { User, IFavorite } from '../shared/model/user';
import { UserService } from '../shared/services/user.service';

@Component({
  selector: 'register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  invalidUserType: boolean;
  emailAlreadyInUse: boolean;
  weekPassword: boolean;
  operationNotAllowed: boolean;
  invalidEmail: boolean;

  form: FormGroup;

  constructor(private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private saveService: SaveService,
    private userService: UserService) {

    this.form = this.fb.group({
      userType: ['', this.radioButtonCheck],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      address: ['', Validators.required],
      city: ['', Validators.required],
      prov: ['', Validators.required],
      country: ['', Validators.required],
      postalCode: ['', Validators.required],
      phoneHouse: ['', Validators.required],
      phoneMobile: ['', Validators.required],
      phoneWork: ['', Validators.required],
      phoneExt: ['', Validators.required],
      emailGroup: this.fb.group({
        email: ['', [Validators.required, Validators.email]],
        emailConfirm: ['', Validators.required]
      }, { validator: this.validateEmailConfirmation }),
      passwordGroup: this.fb.group({
        password: ['', Validators.required],
        passwordConfirm: ['', Validators.required]
      }, { validator: this.validatePasswordConfirmation }),
      notifyBySms: ['', Validators.required],
      notifyByEmail: ['', Validators.required],
      notifyByPhone: ['', Validators.required],
      notifyByPush: ['', Validators.required]
    });

  }

  ngOnInit() {
    this.saveService.setTitle("Créer un compte");
  }

  radioButtonCheck = (control: FormControl): any => {
    if (control.value) {
      this.invalidUserType = false;
      return null;
    }
  }

  validateEmailConfirmation(group: FormGroup) {
    var email = group.controls['email'];
    var emailConfirm = group.controls['emailConfirm'];
    if (email.value !== emailConfirm.value) { // this is the trick
      emailConfirm.setErrors({ validateEmailConfirmation: true });
    }
    return null;
  }

  validatePasswordConfirmation(group: FormGroup) {
    var password = group.controls['password'];
    var passwordConfirm = group.controls['passwordConfirm'];
    if (password.value !== passwordConfirm.value) { // this is the trick
      passwordConfirm.setErrors({ validatePasswordConfirmation: true });
    }
    return null;
  }


  register() {
    if (this.form.value.userType) {
      this.authService.signUp(this.form.controls.emailGroup.value.email, this.form.controls.passwordGroup.value.password)
        .subscribe(
        val => this.save(val.uid),
        err => this.handleError(err.code)
        );
    } else {
      this.invalidUserType = true;
    }
  }

  handleError(error) {
    if (error == "auth/email-already-in-use") {
      this.emailAlreadyInUse = true
    } else if (error == "auth/invalid-email") {
      this.invalidEmail = true
    } else if (error == "auth/operation-not-allowed") {
      this.operationNotAllowed = true
    } else if (error == "auth/weak-password") {
      this.weekPassword = true
    }
  }

  formatUser(value, uid): User {
    const userType = (value.userType === "1" ? "ADMIN" : "NORMAL");
    const notifyBySms = (value.notifyBySms === "" ? false : true);
    const notifyByEmail = (value.notifyByEmail === "" ? false : true);
    const notifyByPhone = (value.notifyByPhone === "" ? false : true);
    const notifyByPush = (value.notifyByPush === "" ? false : true);
    const date = new Date().toDateString();
    const favorite: IFavorite[] = [{ institution: "Created User", type: date }];
    return new User(uid,
      userType,
      value.firstName,
      value.lastName,
      value.address,
      value.city,
      value.prov,
      value.country,
      value.postalCode,
      value.phoneHouse,
      value.phoneMobile,
      value.phoneWork,
      value.phoneExt,
      value.emailGroup.email,
      notifyBySms,
      notifyByEmail,
      notifyByPhone,
      notifyByPush,
      favorite)
  }

  save(val) {

    const user = this.formatUser(this.form.value, val);
    this.userService.saveUser(val, user)
      .subscribe(
      () => {
        this.saveService.setUser(user)
        this.resetForm();
      },
      err => console.log(`error creating lesson ${err}`)
      );

  }

  resetForm() {
    this.form.reset();
    Object.keys(this.form.controls).forEach(key => {
      this.form.controls[key].setErrors(null)
    });
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/register/register.component.ts